import React from "react";
import DashboardLayout from "../../Layouts/Dashboard/dashboard";
import Tabbar from "../../Components/Tabbar";
import { routePaths } from "../../Router/router";
import { Outlet, useLocation } from "react-router";
import DemoTableOfContents from "../../Components/Demo/DemoTableOfContents";
import { useTranslation } from "react-i18next";

function Demo() {
  const { t } = useTranslation();
  const location = useLocation();
  const [wrapperRef, setWrapperRef] = React.useState<HTMLDivElement | null>(null);

  return (
    <DashboardLayout withContainer ref={(ref) => (ref ? setWrapperRef(ref) : undefined)}>
      <h1>{t("page:body.uiKit")}</h1>
      <Tabbar
        tabs={[
          [
            {
              to: routePaths.demo.path,
              label: t("common:core"),
            },
            {
              to: `${routePaths.demo.path}/${routePaths.demoSamples.path}`,
              label: t("route:linkTitle.samples"),
            },
            {
              to: `${routePaths.demo.path}/${routePaths.demoCards.path}`,
              label: t("common:cards"),
            },
            {
              to: `${routePaths.demo.path}/${routePaths.demoTables.path}`,
              label: t("route:linkTitle.tables"),
            },
          ],
        ]}
        sx={{ mb: 2 }}
      />
      {wrapperRef && <DemoTableOfContents wrapperRef={wrapperRef} />}
      <Outlet />
    </DashboardLayout>
  );
}

export default Demo;
